/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Stage_Vector_ScrambleInputs */

const bn_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভেক্টর স্ক্র্যাম্বল`)
};

const de_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vektor-Gerangel`)
};

const el_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διάνυσμα ανακατωσούρα`)
};

const en_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vector scramble`)
};

const es_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lucha vectorial`)
};

const fr_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillage vectoriel`)
};

const hi_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वेक्टर हाथापाई`)
};

const hu_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vektor tülekedés`)
};

const id_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perebutan vektor`)
};

const it_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mischia vettore`)
};

const ja_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベクトルスクランブル`)
};

const ko_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`벡터 스크램블`)
};

const nl_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vector klauteren`)
};

const pl_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mieszanka wektorowa`)
};

const pt_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embaralhamento de vetores`)
};

const ru_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Векторная схватка`)
};

const sv_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vector scramble`)
};

const tr_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vektör mücadelesi`)
};

const uk_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Векторна сутичка`)
};

const vi_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tranh giành véc tơ`)
};

const zh_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`矢量置乱`)
};

const zh_hant_cipher_stage_vector_scramble = /** @type {(inputs: Cipher_Stage_Vector_ScrambleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向量置亂`)
};

/**
* | output |
* | --- |
* | "Vector scramble" |
*
* @param {Cipher_Stage_Vector_ScrambleInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_stage_vector_scramble = /** @type {((inputs?: Cipher_Stage_Vector_ScrambleInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Stage_Vector_ScrambleInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_stage_vector_scramble(inputs)
	if (locale === "de") return de_cipher_stage_vector_scramble(inputs)
	if (locale === "el") return el_cipher_stage_vector_scramble(inputs)
	if (locale === "en") return en_cipher_stage_vector_scramble(inputs)
	if (locale === "es") return es_cipher_stage_vector_scramble(inputs)
	if (locale === "fr") return fr_cipher_stage_vector_scramble(inputs)
	if (locale === "hi") return hi_cipher_stage_vector_scramble(inputs)
	if (locale === "hu") return hu_cipher_stage_vector_scramble(inputs)
	if (locale === "id") return id_cipher_stage_vector_scramble(inputs)
	if (locale === "it") return it_cipher_stage_vector_scramble(inputs)
	if (locale === "ja") return ja_cipher_stage_vector_scramble(inputs)
	if (locale === "ko") return ko_cipher_stage_vector_scramble(inputs)
	if (locale === "nl") return nl_cipher_stage_vector_scramble(inputs)
	if (locale === "pl") return pl_cipher_stage_vector_scramble(inputs)
	if (locale === "pt") return pt_cipher_stage_vector_scramble(inputs)
	if (locale === "ru") return ru_cipher_stage_vector_scramble(inputs)
	if (locale === "sv") return sv_cipher_stage_vector_scramble(inputs)
	if (locale === "tr") return tr_cipher_stage_vector_scramble(inputs)
	if (locale === "uk") return uk_cipher_stage_vector_scramble(inputs)
	if (locale === "vi") return vi_cipher_stage_vector_scramble(inputs)
	if (locale === "zh") return zh_cipher_stage_vector_scramble(inputs)
	return zh_hant_cipher_stage_vector_scramble(inputs)
});